module.exports = __webpack_public_path__ + "img/img_blank_order@2x.5788b5cc.png";